var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FDCECE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C14.0222 6 12.0888 6.58649 10.4443 7.6853C8.79981 8.78412 7.51809 10.3459 6.76121 12.1732C6.00433 14.0004 5.8063 16.0111 6.19215 17.9509C6.578 19.8907 7.53041 21.6725 8.92894 23.0711C10.3275 24.4696 12.1093 25.422 14.0491 25.8078C15.9889 26.1937 17.9996 25.9957 19.8268 25.2388C21.6541 24.4819 23.2159 23.2002 24.3147 21.5557C25.4135 19.9112 26 17.9778 26 16C25.9949 13.3494 24.9397 10.8088 23.0655 8.93455C21.1912 7.06028 18.6506 6.00508 16 6ZM19.625 18.5288C19.7694 18.6747 19.8505 18.8717 19.8505 19.0769C19.8505 19.2822 19.7694 19.4792 19.625 19.625C19.478 19.7672 19.2814 19.8466 19.0769 19.8466C18.8724 19.8466 18.6759 19.7672 18.5288 19.625L16 17.0865L13.4712 19.625C13.3241 19.7672 13.1276 19.8466 12.9231 19.8466C12.7186 19.8466 12.522 19.7672 12.375 19.625C12.2306 19.4792 12.1495 19.2822 12.1495 19.0769C12.1495 18.8717 12.2306 18.6747 12.375 18.5288L14.9135 16L12.375 13.4712C12.2523 13.3217 12.1897 13.132 12.1991 12.9388C12.2086 12.7457 12.2896 12.563 12.4263 12.4263C12.563 12.2896 12.7457 12.2086 12.9388 12.1991C13.132 12.1896 13.3217 12.2523 13.4712 12.375L16 14.9135L18.5288 12.375C18.6783 12.2523 18.868 12.1896 19.0612 12.1991C19.2543 12.2086 19.437 12.2896 19.5737 12.4263C19.7104 12.563 19.7914 12.7457 19.8009 12.9388C19.8104 13.132 19.7477 13.3217 19.625 13.4712L17.0865 16L19.625 18.5288Z",
    fill: "#FF5C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCross);
export default __webpack_public_path__ + "static/media/error-cross.c8cbf223ab66c4e721d753ddb83862f6.svg";
export { ForwardRef as ReactComponent };